'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { parseUA } from '@/helpers/ua-parser';
const toPageSlug = pathname => {
  if (pathname === '/') return 'home';
  return pathname.split('/')[1] || 'home';
};

// Sets data-browser/os/device/touch on <html> once, and data-page on every
// navigation — all consumed by the Tailwind custom variants in src/css/variants.css.
export const DeviceProvider = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  let t3;
  if ($[1] !== pathname) {
    t2 = () => {
      document.documentElement.setAttribute("data-page", toPageSlug(pathname));
    };
    t3 = [pathname];
    $[1] = pathname;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  return children;
};
function _temp() {
  const {
    browser,
    os,
    device
  } = parseUA(navigator.userAgent);
  document.documentElement.setAttribute("data-browser", browser);
  document.documentElement.setAttribute("data-os", os);
  document.documentElement.setAttribute("data-device", device);
  document.documentElement.setAttribute("data-touch", window.matchMedia("(pointer: coarse)").matches);
}